import {host} from 'env'
import http from 'config/http.js'
/**
 * 获取当前用户信息
 */
function getUserInfo(ignoreInterceptor = false) {
    return http.get(`${host.passport}account/info`, {
        ignoreInterceptor
    });
}
/**
 * 获取优惠券活动id
 * @param {id} params 券活动id
 */
function getCoupon(params) {
    return http({
        url: `${host.coupon}iom/welfare/info`,
        method: 'GET',
        params
    })
}
/**
 * 领取优惠券、会员权利
 */
function getCouponPower(params) {
    return http({
        // url: `${host.coupon}m/coupon/activity/draw`,
        url: `${host.coupon}m/iom/voucher/obtain`,
        method: 'POST',
        params
    })
}
export {
    getUserInfo,
    getCoupon,
    getCouponPower
}